import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './Header.css';

interface HeaderProps {
    isAdmin?: boolean;
    onLogout?: () => void;
}

const Header: React.FC<HeaderProps> = ({ isAdmin = false, onLogout }) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [currentLang, setCurrentLang] = useState(i18n.language);
    const { totalItems, setIsCartOpen } = useCart();

    const changeLanguage = (lang: string) => {
        i18n.changeLanguage(lang);
        setCurrentLang(lang);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        }
        navigate('/');
        setIsMenuOpen(false);
    };

    return (
        <header className="header">
            <div className="header-container">
                <Link to="/" className="logo">
                    <img src={require('../../assets/images/acs-logo.png')} alt="ACS Logo" className="logo-img" />
                </Link>

                <button className="mobile-menu-btn" onClick={toggleMenu}>
                    {isMenuOpen ? '✕' : '☰'}
                </button>

                <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
                    <Link to="/" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                        {t('nav.home')}
                    </Link>
                    <Link to="/products" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                        {t('nav.products')}
                    </Link>
                    <Link to="/about" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                        {t('nav.about')}
                    </Link>
                    <Link to="/contact" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                        {t('nav.contact')}
                    </Link>

                    {isAdmin ? (
                        <>
                            <Link to="/admin" className="nav-link admin-link" onClick={() => setIsMenuOpen(false)}>
                                {t('nav.admin')}
                            </Link>
                            <button className="logout-btn" onClick={handleLogout}>
                                Logout
                            </button>
                        </>
                    ) : (
                        <Link to="/login" className="nav-link login-link" onClick={() => setIsMenuOpen(false)}>
                            Admin
                        </Link>
                    )}

                    <button className="cart-btn" onClick={() => setIsCartOpen(true)} title={t('cart.title', 'Cart')}>
                        {t('cart.title', 'Cart')}
                        {totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
                    </button>

                    <div className="language-switcher">
                        <button
                            className={`lang-btn ${currentLang === 'kk' ? 'active' : ''}`}
                            onClick={() => changeLanguage('kk')}
                        >
                            KZ
                        </button>
                        <button
                            className={`lang-btn ${currentLang === 'en' ? 'active' : ''}`}
                            onClick={() => changeLanguage('en')}
                        >
                            EN
                        </button>
                        <button
                            className={`lang-btn ${currentLang === 'ru' ? 'active' : ''}`}
                            onClick={() => changeLanguage('ru')}
                        >
                            RU
                        </button>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
